import { post } from 'api/client';
import { jsonToFormData } from 'utils/formData';

type ChangeUserParams = {
  userId: number;
  pageId: number;
  postId: number;
};

export function changeUserToRetrieveSchedulePushNotification(
  data: ChangeUserParams,
) {
  const params = jsonToFormData({
    user_id: data.userId,
    page_id: data.pageId,
    post_id: data.postId,
  });
  return post('/posts2/ajaxRescheduleInstagramPost', params);
}
